import { SagaReduxAction, ReduxAction } from './helper';

export const requireFirebase = new SagaReduxAction('FIREBASE_BOOTSTRAP');
export const setUserDoc = new ReduxAction('FIREBASE_USER_DOC_SET', doc => doc); 
export const setHasFirebasePrivilege = new ReduxAction('FIREBASE_USER_HAS_PRIVILEGE', (flag, userId) => ({
    flag,
    userId
}));